/* eslint-disable */
import './gt.js'
import geeManchine from './geeManchine.js'
import ocpc from './ocpc.js'
import globalConfig from '@/lib/http/global-config'
import { userAgreement, dataRetained, getOrgList } from '@/utils.js'
import { mapState } from 'vuex'
import debounce from 'lodash/debounce'

const BASE_URL = globalConfig.webServer
const RECORD_URL = 'https://tcms.esign.cn/api/v1'
const COMMON_ERROR_MSG = '网络不给力，请重新尝试～'
const TRIAL_URL = globalConfig.trial

export default {
  mixins: [geeManchine],
  data() {
    return {
      name: '',
      companyName: '',
      phoneCode: '',
      phoneNumber: '',
      codeName: '获取验证码',
      countdown: 0,
      tryButtontxt: '',
      isClick: false,
      isCompanyActive: false,
      isPhoneActive: false,
      isNameActive: false,
      isCodeActive: false,
      changeBtnBg: false,
      hasHumanCheckSlide: false, // 有人机校验的滑动条
      serviceId: null,
      submitSuccess: false,
      originTryButtontxt: this.$route.path === '/chunsheng' ? '立即领取' : '提交试用信息',
      BASE_URL: BASE_URL,
      agreement: userAgreement.enable, // 隐私协议
      showErrorTip: false,
      userAgreement,
      companyList: [], // 联想查询的公司列表
      showCompanyList: true, // 点击单个公司回显input框上，查询的公司列表消失
      takeNoteschooseOrg: false, // 记录是点击联想公司，用于埋点上报
    }
  },
  created() {
    document.addEventListener('click', (e) => {
      // 点击其他区域，联想列表消失
      this.showCompanyList = false
    })
  },
  mounted() {
    this.tryButtontxt = this.originTryButtontxt
  },
  methods: {
    ...ocpc.methods,

    reset() {
      this.companyName = ''
      this.phoneNumber = ''
      this.phoneCode = ''
      this.name = ''
      this.isClick = ''
      this.agreement = this.userAgreement.enable
      this.showErrorTip = false
      this.takeNoteschooseOrg = false // 置为默认状态：是用户手动输入的，没有点击联想列表中的数据
    },

    // 新埋点
    da(eventName) {
      this.$tsignData.track(eventName, {
        name: this.name,
        phone: this.phoneNumber,
        // eslint-disable-next-line camelcase
        company_name: this.companyName,
        // eslint-disable-next-line camelcase
        is_dingding_user: null,
      })
    },
    onfousFun() {
      if (this.isPhoneActive) {
        this.isClick = false
        if (this.checkPhoneInvalid(this.phoneNumber) || this.phoneNumber === '' || this.phoneNumber === '请输入您的联系方式') {
          this.phoneNumber = '请输入您的联系方式'
          this.isClick = true
        }
      }

      if (this.isNameActive) {
        this.isClick = false
        if (this.checkNameInvalid(this.name) || this.name === '' || this.name === '请输入您的姓名(中文)') {
          this.name = '请输入您的姓名(中文)'
          this.isClick = true
        }
      }

      if (this.isCompanyActive) {
        this.isClick = false
        if (this.checkCompany(this.companyName) || this.companyName === '' || this.companyName === '请输入公司名称(中文)') {
          this.companyName = '请输入公司名称(中文)'
          this.isClick = true
        }
      }
      if (this.isCodeActive) {
        this.isClick = false
        if (this.phoneCode === '' || this.phoneCode === '请输入验证码') {
          this.phoneCode = '请输入验证码'
          this.isClick = true
        }
      }
    },
    clearData(type) {
      if (![0, 1, 2, 3].includes(type)) return

      const propName = ['name', 'companyName', 'phoneNumber', 'phoneCode'][type]
      const placeholder = ['请输入您的姓名(中文)', '请输入公司名称(中文)', '请输入您的联系方式', '请输入验证码'][type]

      if (this[propName] === placeholder) {
        this[propName] = ''
      }

      const str = ['Name', 'Company', 'Phone', 'Code'][type]
      this[`is${str}Active`] = true
    },

    // 获取验证码按钮点击回调
    handleFetchCodeClick() {
      if (this.phoneNumber && this.checkPhoneInvalid(this.phoneNumber)) {
        this.fail({ content: '请填写正确的手机号' })
      }
      if (this.phoneNumber === '' || this.phoneNumber === '请输入您的联系方式') {
        this.phoneNumber = '请输入您的联系方式'
        this.isClick = true

        return
      }

      if (this.countdown > 0) return

      this.da('sign_landingpage_getverificationcode')
      this.geeManMachineCheck(this.phoneNumber)
        .then((result) => {
          this.fetchCode(result)
        })
        .catch(() => {
          this.fail({ content: '人机校验失败' })
        })
    },

    // 获取验证码
    async fetchCode(payload = {}) {
      try {
        this.countdown = 60
        this.updateCodeBtnText()
        const res = await this.$axios({
          baseURL: BASE_URL,
          url: 'sender/mobile/v3',
          method: 'post',
          data: {
            bizType: 'LAND_PAGE_AUTHORIZE',
            principal: this.phoneNumber,
            auth: {
              ...payload,
            },
          },
        })
        this.serviceId = res.data.serviceId

        return true
      } catch (err) {
        this.fail({ content: COMMON_ERROR_MSG })
        this.countdown = 0
        this.updateCodeBtnText()

        return false
      }
    },

    // 更新 获取验证码 按钮的文案
    updateCodeBtnText() {
      if (+this.countdown === 0) {
        this.codeName = '获取验证码'

        return false
      }
      this.codeName = `重新发送(${this.countdown})秒`
      this.countdown--
      setTimeout(() => this.updateCodeBtnText(), 1000)
    },

    // 提交试用信息 点击事件
    async handleSendInfoBtnClick(pageName) {
      // 增加点击‘提交试用信息’的埋点
      this.$tsignData.track('front_before_request_trial', {
        userName: this.name,
        userPhone: this.phoneNumber,
        companyName: this.companyName,
      })
      if (!this.serviceId) {
        return this.fail({ content: '请先获取验证码' })
      }
      const { name, companyName, phoneNumber } = this
      if (this.checkNameInvalid(name) || name === '' || name === '请输入您的姓名(中文)') {
        this.name = '请输入您的姓名(中文)'
        this.isClick = true
      }
      if (this.checkCompany(companyName) || companyName === '' || companyName === '请输入公司名称(中文)') {
        this.companyName = '请输入公司名称(中文)'
        this.isClick = true
      }
      if (this.checkPhoneInvalid(phoneNumber) || phoneNumber === '' || phoneNumber === '请输入您的联系方式') {
        this.phoneNumber = '请输入您的联系方式'
        this.isClick = true
      }
      if (this.phoneCode === '' || this.phoneCode === '请输入验证码') {
        this.phoneCode = '请输入验证码'
        this.isClick = true
      }
      if (this.isClick) {
        return
      }

      if (!this.agreement) {
        this.showErrorTip = true // 请先阅读并同意协议
        return
      }
      this.showErrorTip = false
      this.tryButtontxt = '提交中'
      this.changeBtnBg = true
      this.submitSuccess = false
      const res = await this.$axios({
        url: 'sender/verify',
        method: 'post',
        baseURL: BASE_URL,
        data: {
          credentials: this.phoneCode,
          serviceId: this.serviceId,
        },
      })
      const code = +res.code
      if (code !== 0 && code !== 200) {
        this.tryButtontxt = this.originTryButtontxt
        this.changeBtnBg = false
        return this.fail({ content: res.message || COMMON_ERROR_MSG })
      }

      // 增加数据备份
      // const resCopy = await this.$axios({
      //   url: 'api/server/addQuotation',
      //   method: 'post',
      //   baseURL: RECORD_URL,
      //   data: {
      //     userName: this.name,
      //     companyName: this.companyName,
      //     mobile: this.phoneNumber,
      //   },
      // })
      // if (!resCopy || (resCopy && !resCopy.succ)) {
      //   this.changeBtnBg = false
      //   return this.fail({ COMMON_ERROR_MSG })
      // }
      // 线索转换接口
      // const instance = axios.create({ headers: {}, baseURL: TRIAL_URL })
      // delete instance.defaults.headers['X-Tsign-Client-AppName']
      // delete instance.defaults.headers['X-Tsign-Client-Id']
      // delete instance.defaults.headers['X-Tsign-Open-App-Id']
      // delete instance.defaults.headers['X-Tsign-Open-Tenant-Id']
      // function getNowDate() {
      //   var date = new Date()
      //   var year = date.getFullYear()
      //   var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      //   var day = date.getDay() < 10 ? '0' + date.getDay() : date.getDay()
      //   var hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      //   var minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      //   var second = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      //   return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
      // }
      // instance({
      //   baseURL: TRIAL_URL,
      //   url: '/crm-clue/api/v1/clues/out/addClue',
      //   method: 'POST',
      //   data: {
      //     event: 'front_apply_trial',
      //     username: this.name,
      //     userphone: this.phoneNumber,
      //     companyname: this.companyName,
      //     _latest_tsign_source_type: 'OFFICIAL',
      //     user_id: 1,
      //     _latest_tsign_source_detail: 'NATURE',
      //     platformtype: window.screen.width > 1024 ? 'WEB' : 'H5',
      //     time: getNowDate(),
      //     title: document.title,
      //     linkUrl: window.location.href,
      //   },
      // })
      // TODO:
      if (this.landingPageName === 'esignPropagate') {
        // eslint-disable-next-line camelcase
        window.meteor && window.meteor.track && window.meteor.track('form', { convert_id: '1655145449179140' })
      }
      this.da('sign_landingpage_freetry')

      // 为common页面添加搜狗ocpc
      const { path, query } = this.$route
      if (path === '/landing/common' && query.sg_vid) {
        this.requestSougou()
      }

      // 后端数据留存
      dataRetained(this.$axios, {
        companyName: this.companyName, // 公司名称
        contactName: this.name, // 联系人名称
        contactPhone: this.phoneNumber, // 联系人电话
      })
      // let orgname_source = this.orgnameSource()
      let frontApplyTrialObj = {
        userName: this.name,
        userPhone: this.phoneNumber,
        companyName: this.companyName,
        $url: window.location.href,
        // orgname_source: orgname_source.apply_trial_use_name, // 区分企业名称来源
        // $latest_utm_campaign: orgname_source.crm_use_name, // 用在运营支撑平台上，crm线索管理【所属活动】字段传入以上信息便于跟踪后续线索转化
        chl: 'trial',
        tml: 'tsign',
        pub: this.pub,
      }
      if (pageName && pageName === 'smartContract') {
        // 用于smartContract这个落地页增加来源详情埋点
        frontApplyTrialObj._latest_tsign_source_detail = '智能合同推广V1' // 来源详情
        // 用于smartContract这个落地页增加来源类型埋点
        frontApplyTrialObj._latest_tsign_source_type = 'ONLINE_PROMOTION' // 来源类型，ONLINE_PROMOTION表示‘线上推广’
      }
      this.$tsignData.track(
        'front_apply_trial',
        frontApplyTrialObj,

        // 等埋点请求返回后再跳转
        () => {
          // 百度埋点
          window._agl && window._agl.push(['track', ['success', { t: 3 }]])
          this.changeBtnBg = false
          this.tryButtontxt = this.originTryButtontxt
          if (this.isH5) {
            this.$emit('submitSuccess')
          } else {
            this.closeForm = false
          }
          this.submitSuccess = true
          this.reset()
        }
      )

      // 埋点请求没返回
      setTimeout(() => {
        this.changeBtnBg = false
        this.tryButtontxt = this.originTryButtontxt
        if (!this.submitSuccess) {
          this.fail({ content: COMMON_ERROR_MSG })
        }
      }, 3000)
    },

    checkPhoneInvalid(phone) {
      return !/^[1][0-9][0-9]{9}$/.test(phone)
    },
    checkNameInvalid(name) {
      return !/^[\u4e00-\u9fa5]+$/.test(name)
    },
    checkCompany(company) {
      return !/^[\u2E80-\uFE4F () （）]+$/.test(company)
    },
    showMsg({ type, title, content }) {
      this.$emit('msg', { type, title, content })
    },
    success({ title = '提交成功', content }) {
      this.$emit('msg', { type: 'success', title, content })
    },
    fail({ title = '提交失败', content }) {
      this.$emit('msg', { type: 'fail', title, content })
    },
    // 20230416迭代中，增加企业名称支持联想输入
    async handleAssociativeInputSearch() {
      // if (this.companyName.trim().length < 6) {
      //   this.companyName = '企业名称不可少于6个字'
      //   this.isClick = true
      //   return
      // }
      // 去掉首尾空格
      this.companyName = this.companyName.replace(/^\s+|\s+$/g, '')
      // 发送搜索请求
      const { data, code } = await getOrgList(this.$axios, this.companyName)
      if (code === 0) {
        this.companyList = data.orgInfos
      }
    },
    //500ms延迟
    changeInput: debounce(function () {
      if (this.companyName.trim().length >= 6) {
        this.handleAssociativeInputSearch()
      }
    }, 500),
    // 点击单个公司，回填到input框中
    chooseOrg(data) {
      this.companyName = data.name
      this.showCompanyList = false // 联想列表关闭
      this.takeNoteschooseOrg = true // 是点击联想列表中数据
    },
    // 区分企业名称来源，用于埋点上报
    orgnameSource() {
      /**
       * 分三种情况：
       * 1、公司名称仅输入不支持联想
       * 2、公司名称联想列表勾选（用户从联想的下拉列表中选择了公司）
       * 3、公司名称联想列表未勾选（有联想的下拉列表，但是用户仍然手动输入）
       * 其中，第一条是走的abtest中（老）留资企业名称，第二、第三条是走的abtest中（新）留资企业名称
       */
      if (this.abTestPlan === 'name_input') {
        // 表示（老）留资企业名称
        return {
          apply_trial_use_name: 'orgname_input', // apply_trial_use_name用在神策上查询
          crm_use_name: '名称仅输入不支持联想', // crm_use_name用在运营支撑平台上，crm线索管理【所属活动】字段传入以上信息便于跟踪后续线索转化
        }
      } else {
        // name_association，表示（新）留资企业名称
        if (this.takeNoteschooseOrg) {
          // 用户点击了联想里的企业
          return {
            apply_trial_use_name: 'orgname_association_select',
            crm_use_name: '名称联想列表勾选',
          }
        } else {
          // 有联想企业，但仍然手动输入
          return {
            apply_trial_use_name: 'orgname_association_not_selected',
            crm_use_name: '名称联想列表未勾选',
          }
        }
      }
    },
  },
  computed: {
    ...mapState('abTest', ['abTestPlan']),
    pub() {
      return this.$route.query.pub
    },
  },
}
